(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gigatech-rapid-builder"] && !Shopify.designMode) return;
  try {
    class GigatechRapidBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.steps = [...this.querySelectorAll('[data-rb-step]')];
      this.progress = this.querySelector('[data-rb-progress]');
      this.progressLabel = this.querySelector('[data-rb-progress-label]');
      this.resultGrid = this.querySelector('[data-rb-result-grid]');
      this.resultsHeading = this.querySelector('[data-rb-results-heading]');
      this.resultsText = this.querySelector('[data-rb-results-text]');
      this.answerChips = this.querySelector('[data-rb-answer-chips]');
      this.cartError = this.querySelector('[data-rb-cart-error]');
      const source = this.querySelector('[data-rb-products]');
      const parsed = source ? JSON.parse(source.textContent) : { products: [], accessory: null };
      this.products = (parsed.products || []).filter(Boolean);
      this.accessory = parsed.accessory || null;
      this.currentStep = 0;
      this.state = { budget: '', style: '', games: [], bundle: '' };
      this.addEventListener('click', this.handleClick);
      this.addEventListener('change', this.handleChange);
      this.showStep(0, false);
    }

    handleClick = (event) => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-rb-start]')) {
        this.showStep(1);
        this.track('rapid_builder_started');
        return;
      }
      if (button.matches('[data-rb-back]')) {
        this.showStep(Math.max(0, this.currentStep - 1));
        return;
      }
      if (button.matches('[data-rb-next]')) {
        if (!this.captureStep(this.currentStep)) return;
        if (this.currentStep === 4) {
          this.renderResults();
          this.showStep(5);
        } else {
          this.showStep(this.currentStep + 1);
        }
        return;
      }
      if (button.matches('[data-rb-edit]')) {
        this.showStep(1);
        return;
      }
      if (button.matches('[data-rb-restart]')) {
        this.querySelectorAll('input').forEach((input) => {
          input.checked = false;
        });
        this.state = { budget: '', style: '', games: [], bundle: '' };
        this.showStep(0);
        this.track('rapid_builder_restarted');
        return;
      }
      if (button.matches('[data-rb-add]')) {
        this.addRecommendation(button);
      }
    };

    handleChange = (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;
      const error = event.target.closest('form')?.querySelector('[data-rb-error]');
      if (error) error.hidden = true;
    };

    captureStep(step) {
      const panel = this.steps.find((item) => Number(item.dataset.rbStep) === step);
      if (!panel) return false;
      const error = panel.querySelector('[data-rb-error]');
      let valid = true;
      if (step === 1) {
        const selected = panel.querySelector('input[name="budget"]:checked');
        this.state.budget = selected?.value || '';
        valid = Boolean(selected);
      }
      if (step === 2) {
        const selected = panel.querySelector('input[name="style"]:checked');
        this.state.style = selected?.value || '';
        valid = Boolean(selected);
      }
      if (step === 3) {
        this.state.games = [...panel.querySelectorAll('input[name="games"]:checked')].map((input) => input.value);
        valid = this.state.games.length > 0;
      }
      if (step === 4) {
        const selected = panel.querySelector('input[name="bundle"]:checked');
        this.state.bundle = selected?.value || '';
        valid = Boolean(selected);
      }
      if (!valid && error) {
        error.textContent = this.dataset.questionError;
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (valid) this.track('rapid_builder_answered', { question: step });
      return valid;
    }

    showStep(step, animate = true) {
      const update = () => {
        this.currentStep = step;
        this.steps.forEach((panel) => {
          panel.hidden = Number(panel.dataset.rbStep) !== step;
        });
        this.updateProgress();
        const heading = this.steps.find((panel) => Number(panel.dataset.rbStep) === step)?.querySelector('h1, h2, .gg-rb__question-title');
        requestAnimationFrame(() => heading?.focus({ preventScroll: true }));
        this.scrollIntoView({ behavior: animate ? 'smooth' : 'auto', block: 'start' });
      };
      if (animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    updateProgress() {
      const question = Math.min(4, Math.max(0, this.currentStep));
      this.progress.hidden = this.currentStep === 0;
      this.progressLabel.textContent = this.dataset.progressTemplate
        .replace('__CURRENT__', String(question))
        .replace('__COUNT__', String(question));
      this.querySelectorAll('[data-rb-segment]').forEach((segment) => {
        const index = Number(segment.dataset.rbSegment);
        segment.dataset.state = index < question || this.currentStep === 5 ? 'complete' : index === question ? 'current' : 'upcoming';
      });
    }

    selectedLabel(name, value) {
      const input = this.querySelector(`input[name="${name}"][value="${value}"]`);
      return input?.dataset.label || value;
    }

    priceFitsBudget(product) {
      const price = Number(product.priceCents) || 0;
      if (this.state.budget === 'low') return price <= 120000;
      if (this.state.budget === 'mid') return price >= 120000 && price <= 180000;
      if (this.state.budget === 'high') return price >= 180000;
      return false;
    }

    renderResults() {
      const demandingGames = new Set(['gta', 'warzone', 'cyberpunk']);
      const requiresDemanding = this.state.games.some((game) => demandingGames.has(game));
      const requiredForm = ['monitor', 'both'].includes(this.state.bundle) ? 'bundle' : 'tower';
      const exact = this.products
        .filter((product) => this.priceFitsBudget(product))
        .filter((product) => this.state.style === 'any' || product.styles.includes(this.state.style))
        .filter((product) => !requiresDemanding || product.demanding)
        .filter((product) => product.form === requiredForm)
        .sort((a, b) => a.priceCents - b.priceCents);

      let results = exact;
      let isClosest = false;
      if (!results.length) {
        isClosest = true;
        results = this.products
          .filter((product) => product.form === requiredForm)
          .filter((product) => !requiresDemanding || product.demanding)
          .map((product) => ({
            product,
            score:
              (this.priceFitsBudget(product) ? 10 : 0) +
              (this.state.style === 'any' || product.styles.includes(this.state.style) ? 4 : 0),
          }))
          .sort((a, b) => b.score - a.score || a.product.priceCents - b.product.priceCents)
          .slice(0, 3)
          .map((item) => item.product);
      }

      this.resultsHeading.textContent = isClosest
        ? this.dataset.closestHeading
        : results.length === 1
          ? this.dataset.exactHeadingOne
          : this.dataset.exactHeading.replace('__COUNT__', String(results.length));
      this.resultsText.textContent = isClosest ? this.dataset.closestText : this.dataset.exactText;
      this.renderAnswerChips();

      if (!results.length) {
        this.resultGrid.innerHTML = `<p class="gg-rb__error">${this.escapeHtml(this.dataset.noProducts)}</p>`;
        return;
      }

      this.resultGrid.innerHTML = results
        .map((product, index) => this.productCard(product, index, isClosest))
        .join('');
      this.track('rapid_builder_results', {
        count: results.length,
        closest: isClosest,
        products: results.map((product) => product.key),
      });
    }

    renderAnswerChips() {
      const labels = [
        this.selectedLabel('budget', this.state.budget),
        this.selectedLabel('style', this.state.style),
        ...this.state.games.map((game) => this.selectedLabel('games', game)),
        this.selectedLabel('bundle', this.state.bundle),
      ];
      this.answerChips.innerHTML = labels.map((label) => `<span>${this.escapeHtml(label)}</span>`).join('');
    }

    productCard(product, index, isClosest) {
      const rank = isClosest
        ? this.dataset.closestMatch
        : index === 0
          ? this.dataset.bestMatch
          : this.dataset.alsoMatch;
      const from = product.priceVaries ? `<small>${this.escapeHtml(this.dataset.from)}</small>` : '';
      const accessory =
        this.state.bundle === 'mouse-keyboard' && this.accessory?.title
          ? `<p class="gg-rb__accessory">${this.escapeHtml(this.dataset.accessoryPrefix)} ${this.escapeHtml(this.accessory.title)} · ${this.escapeHtml(this.accessory.priceText)}</p>`
          : '';
      const fitChips = [
        this.priceFitsBudget(product) ? this.dataset.budgetFit : this.dataset.budgetOutside,
        this.state.style === 'any' || product.styles.includes(this.state.style)
          ? this.dataset.styleFit
          : this.dataset.styleDifference,
        this.dataset.gamesFit.replace('__COUNT__', String(this.state.games.length)),
        this.dataset.setupFit,
      ]
        .map((label) => `<span class="gg-rb__fit-chip">${this.escapeHtml(label)}</span>`)
        .join('');
      const addLabel =
        this.state.bundle === 'mouse-keyboard' ? this.dataset.addTowerCombo : this.dataset.addBuild;
      const addButton =
        product.available && product.variantId
          ? `<button class="gg-rb__button gg-rb__button--primary" type="button" data-rb-add data-variant-id="${this.escapeHtml(String(product.variantId))}" data-default-label="${this.escapeHtml(addLabel)}">${this.escapeHtml(addLabel)}</button>`
          : `<span class="gg-rb__button gg-rb__button--back">${this.escapeHtml(this.dataset.soldOut)}</span>`;
      const image = product.image
        ? `<img src="${this.escapeHtml(product.image)}" alt="${this.escapeHtml(product.imageAlt)}" loading="${index === 0 ? 'eager' : 'lazy'}" width="900" height="900">`
        : '';
      return `
        <article class="gg-rb__result-card">
          <a class="gg-rb__result-media" href="${this.escapeHtml(product.url)}">
            <span class="gg-rb__result-rank">${this.escapeHtml(rank)}</span>
            ${image}
          </a>
          <div class="gg-rb__result-body">
            <h3>${this.escapeHtml(product.title)}</h3>
            <p class="gg-rb__price">${from}${this.escapeHtml(product.priceText)}</p>
            <p class="gg-rb__result-description">${this.escapeHtml(product.description)}</p>
            <div class="gg-rb__fit-list">${fitChips}</div>
            ${accessory}
            <div class="gg-rb__result-actions">
              ${addButton}
              <a class="gg-rb__button gg-rb__button--back" href="${this.escapeHtml(product.url)}">${this.escapeHtml(this.dataset.viewCustomize)}</a>
              <p class="gg-rb__result-note">${this.escapeHtml(this.dataset.startingNote)}</p>
            </div>
          </div>
        </article>
      `;
    }

    async addRecommendation(button) {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      const items = [{ id: variantId, quantity: 1 }];
      if (
        this.state.bundle === 'mouse-keyboard' &&
        this.accessory?.available &&
        Number(this.accessory.variantId)
      ) {
        items.push({ id: Number(this.accessory.variantId), quantity: 1 });
      }
      this.cartError.hidden = true;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('cart');
        this.track('rapid_builder_added_to_cart', { items: items.length });
        window.location.assign(this.dataset.cartUrl);
      } catch {
        button.disabled = false;
        button.textContent = button.dataset.defaultLabel;
        this.cartError.textContent = this.dataset.addError;
        this.cartError.hidden = false;
      }
    }

    escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    track(event, detail = {}) {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...detail });
      this.dispatchEvent(new CustomEvent(`gigatech:${event}`, { bubbles: true, detail }));
    }
  }

  if (!customElements.get('rapid-builder')) {
    customElements.define('rapid-builder', GigatechRapidBuilder);
  }
  } catch(e) { console.error(e); }
})();

})();
